export interface MovieCategory {
  key: string;
  name: string;
  desc: string;
  count: string;
  image: string;
}

export const movieCategories: MovieCategory[] = [
  {
    key: "电影",
    name: "电影",
    desc: "院线新片与口碑佳作",
    count: "1,280 部",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage%20style%20banner%20representing%20movies%20with%20a%20film%20reel%20and%20glowing%20screen%20silhouette%2C%20deep%20blue%20background%20with%20warm%20orange%20spotlight%20beams%2C%20stylized%20geometric%20composition%2C%20textured%20grain%2C%20elegant%20and%20modern%2C%20high%20detail&width=800&height=500&seq=cat-movie-01&orientation=landscape",
  },
  {
    key: "电视剧",
    name: "电视剧",
    desc: "热播剧集每日更新",
    count: "960 部",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20banner%20representing%20tv%20series%20with%20a%20stack%20of%20glowing%20television%20screens%20in%20a%20dark%20room%2C%20deep%20blue%20ambience%20with%20warm%20orange%20screen%20glow%2C%20stylized%20geometric%20composition%2C%20cinematic%20texture%2C%20high%20detail&width=800&height=500&seq=cat-tv-01&orientation=landscape",
  },
  {
    key: "综艺",
    name: "综艺",
    desc: "轻松欢乐综艺合集",
    count: "420 部",
    image:
      "https://readdy.ai/api/search-image?query=Playful%20banner%20representing%20variety%20shows%20with%20stage%20microphones%20neon%20shapes%20and%20confetti%2C%20vibrant%20orange%20and%20deep%20blue%20palette%2C%20stylized%20graphic%20composition%2C%20energetic%20modern%20look%2C%20high%20detail&width=800&height=500&seq=cat-variety-01&orientation=landscape",
  },
  {
    key: "纪录片",
    name: "纪录片",
    desc: "探索真实世界之美",
    count: "310 部",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20banner%20representing%20documentaries%20with%20a%20globe%20and%20lens%20aperture%20motif%20over%20a%20textured%20map%2C%20deep%20blue%20and%20warm%20amber%20palette%2C%20stylized%20minimal%20composition%2C%20sophisticated%20and%20cinematic%2C%20high%20detail&width=800&height=500&seq=cat-doc-01&orientation=landscape",
  },
];